export const suppressConsoleError = (shouldBeHidden: (message: string) => boolean) => {
  const err = console.error;
  console.error = (message?: any, ...optionalParams: any[]) => {
    if (typeof message === 'string' && shouldBeHidden(message)) {
      return;
    }
    err(message, ...optionalParams);
  };
};
